import { DialogContent } from "@mui/material";
import {
  Autocomplete,
  DateTimePicker,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import I18n from "i18n";
import { HistoryChanges } from "./HistoryChanges";
import useHistoryForm, { UseHistoryFormProps } from "./useHistoryForm";
export interface HistoryFormProps extends UseHistoryFormProps {}

export default function HistoryForm({
  id,
  afterSave,
  onClose,
}: HistoryFormProps) {
  const {
    params,
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    isUpdate,
    getIsDirty,
    requiredFields,
    onChange,
    save,
    saving,
  } = useHistoryForm({
    id,
    afterSave,
  });
  //const title = I18n.t("History.title");
  const title = I18n.t(`History.events.${item?.event}`);
  const subtitle = item.item_label;
  /*isCreate
    ? I18n.t("History.addTitle")
    : I18n.t("History.editTitle");*/
  return (
    <>
      <PageHeader
        title={title}
        subtitle={subtitle}
        onClose={onClose}
        loading={loading}
      />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="History.attributes"
          isDirty={getIsDirty}
          requiredFields={requiredFields}
          disabled
        >
          <FieldsContainer>
            <Field fullWidth>
              <HistoryChanges
                id="data"
                objectName={item.class_name}
                event={item.event}
              />
            </Field>
            {!params?.user_id && (
              <Field fullWidth>
                <Autocomplete id="user_id" />
              </Field>
            )}
            <Field fullWidth>
              <DateTimePicker id="created_at" />
            </Field>
            <Field fullWidth>
              <TextField id="class_name" />
            </Field>
            <Field fullWidth>
              <TextField id="item_id" />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
    </>
  );
}
